import { ChevronRight } from "lucide-react";
import { nf } from "@/lib/format";
import { L } from "@/i18n";

const btn = (active) =>
  `w-full flex items-center justify-between gap-2 rounded-md px-3 py-2 text-left text-xs transition-colors ${
    active ? "bg-amber-500/10 text-amber-400" : "text-slate-300 hover:bg-slate-800/60 hover:text-slate-100"
  }`;

const Count = ({ n }) => <span className="shrink-0 font-mono text-[11px] text-slate-500">{nf.format(n)}</span>;

export const ModuleNav = ({ modules, total, selected, onSelect }) => {
  const openModule = selected === "all" ? null : selected.split(".")[0];
  return (
    <nav className="space-y-1" data-testid="module-nav">
      <button className={btn(selected === "all")} onClick={() => onSelect("all")} data-testid="module-nav-all">
        <span className="font-medium">{L("All questions", "Todas as perguntas")}</span>
        <Count n={total} />
      </button>
      {modules.map((m) => {
        const open = openModule === m.id;
        return (
          <div key={m.id}>
            <button className={btn(selected === m.id)} onClick={() => onSelect(m.id)} data-testid={`module-nav-${m.id}`}>
              <span className="flex items-center gap-2 min-w-0">
                <ChevronRight className={`h-3.5 w-3.5 shrink-0 transition-transform duration-200 ${open ? "rotate-90" : ""}`} />
                <b className="font-mono text-amber-500/90">{m.id}</b>
                <span className="truncate">{m.name}</span>
              </span>
              <Count n={m.count} />
            </button>
            {open && (
              <div className="ml-5 mt-1 mb-2 border-l border-slate-800 pl-2 space-y-0.5">
                {m.submodules?.map((s) => (
                  <button key={s.id} className={btn(selected === s.id)} onClick={() => onSelect(s.id)} disabled={!s.count} data-testid={`submodule-nav-${s.id}`}>
                    <span className="flex items-center gap-2 min-w-0">
                      <span className="font-mono text-slate-500">{s.id}</span>
                      <span className={`truncate ${s.count ? "" : "text-slate-600"}`}>{s.name}</span>
                    </span>
                    <Count n={s.count} />
                  </button>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </nav>
  );
};
